export default __webpack_public_path__ + "static/msi-a89f01aa168d98cb0fab8e6459bf09d0.jpg";